import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-tag-online-indicator',
    templateUrl: './tag-online-indicator.component.html',
    styleUrls: ['./tag-online-indicator.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TagOnlineIndicatorComponent implements OnInit {

  _movingAnimationIntervalId: NodeJS.Timeout;


  @Input() isOnline: boolean;

  @Input()
  isMoving: boolean = false;


  movingAnimationToggle: boolean = false;
  constructor() { }

  ngOnInit(): void {
  }


}
